module.exports = __webpack_public_path__ + "static/media/badge.eb5dd699.png";